import getUrlParamsToObject from './getUrlParamsToObject';

/**
 * Determines the traffic sources based on URL parameters.
 * @param {string} url - The URL to analyze for traffic source identification.
 * @returns {string|null} - An array of potential traffic sources derived from the URL parameters.
 */
export default function getTrafficSource(url) {
	const params = getUrlParamsToObject(url);
	if (!params) {
		return null;
	}

	if (!url) {
		url = window.location.href.replace(window.location.hash, '');
	}

	// Normalize keys to lower case for case-insensitive matching
	const normalizedParams = Object.fromEntries(
		Object.entries(params).map(([key, value]) => [key.toLowerCase(), value])
	);

	const hasSemIdentifiers = url.includes('gclid') || url.includes('msclkid') || url.includes('=SEM');
	const hasQuadlink = 'quadlink' in normalizedParams;
	const hasCCIDorCLK = 'ccid' in normalizedParams || 'clk' in normalizedParams;
	const hasAVMParam = normalizedParams.channel && normalizedParams.channel.toLowerCase() === 'avm';

	// Rule: AVM channel
	if (hasAVMParam) {
		return 'avm';
	}

	// Rule: SEM traffic based on gclid, msclkid or =SEM, and absence of CCID/CLK
	if (hasSemIdentifiers && !hasCCIDorCLK && !hasAVMParam) {
		return 'sem';
	}

	// Rule: Publisher or Email traffic
	if (hasCCIDorCLK && !hasQuadlink && !hasAVMParam) {
		return 'pub';
	}

	return null;
}
